import { render, staticRenderFns } from "./AppointmentConfigModal.vue?vue&type=template&id=335e8124&scoped=true"
import script from "./AppointmentConfigModal.vue?vue&type=script&lang=js"
export * from "./AppointmentConfigModal.vue?vue&type=script&lang=js"
import style0 from "./AppointmentConfigModal.vue?vue&type=style&index=0&id=335e8124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e8124",
  null
  
)

export default component.exports